import React, {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';

// actions
import {validarAction} from '../../../application/actions/validar';
import {desafiosAction} from '../../../application/actions/desafios';
import {generarDesafioCPAction} from '../../../application/actions/generarDesafioCP';
import {validarDesafioCPAction} from '../../../application/actions/validarDesafioCP';
import {generarDesafioTcooAction} from '../../../application/actions/generarDesafioTcoo';
import {validarDesafioTcooAction} from '../../../application/actions/validarDesafioTcoo';

// componetns
import AutorizacionTemplate from '../../components/templates/Autorizacion/index';
import {informarAction} from '../../../application/actions/informar';
import {sesionAction} from '../../../application/actions/sesion';
import {revokeTokenAction} from '../../../application/actions/revokeToken';
import Mensaje from '../../components/atoms/CajaBloqueo';

//Imagenes
import errorImagen from '../../assets/img/icon-error.svg';

const DESAFIO_NO_DISPONIBLE = 4;

const AutorizacionContainer = () => {
  let history = useHistory();
  const dispatch = useDispatch();
  const trackId = localStorage.getItem('Track-Id');
  const interval = localStorage.getItem('setIntervalPassCoopeuch');
  const [customHelperProperties, setCustomHelperProperties] = useState(null);
  const [comprobante, comprobanteSet] = useState({
    datos: '',
  });

  const [disableInputTcoo, setDisableInputTcoo] = useState(false);
  const [valuesCoordenadas, setValues] = useState(['', '', '']);
  const [state, setState] = useState({
    timerStatus: false,
    logo: '',
    desafios: [],
    coordenadas: '',
    estadoTcoo: '',
    estadoPassCoopeuch: '',
    tercerFactorDisp: false,
    loderAction: false,
    saldoDisponible: true,
    tarjetaActiva: true,
    usuarioCancelo: false,
    appBloqueada: false,
    flag: false,
    casoBorde: false,
    botonPagar: false,
    mostrarCoordenadasSMS: false,
    disabledCoordenadasSMS: false,
    mensajeErrorEnviarDigitosSMS: '',
    mensajeExitoEnviarDigitosSMS: 'Ingresado correctamente',
    celular: '',
    casoBordeIntentosFallidos: false,
    casoBordeErrorGenerico: false,
    sinFactorStado: false,
    passcoopeuchCompletado: false,
    tcooCompletado: false,
  });
  const storeData = useSelector((store) => store.entities.validarReducer);
  const storeDataIngresar = useSelector((store) => store.entities.ingresarReducer);
  const storeDataTransaccion = useSelector((store) => store.entities.transaccionReducer);
  const storeDataDesafio = useSelector((store) => store.entities.desafiosReducer);
  const storeDataGenerarCP = useSelector((store) => store.entities.generarDesafioCPReducer);
  const storeDataValidarCP = useSelector((store) => store.entities.validarDesafioCPReducer);
  const storeDataGenerarTcoo = useSelector((store) => store.entities.generarDesafioTcooReducer);
  const storeDataValidarTcoo = useSelector((store) => store.entities.validarDesafioTcooReducer);
  const storeDataInformar = useSelector((store) => store.entities.informarReducer);
  const storeDataSesion = useSelector((store) => store.entities.sesionReducer);
  const storeRevoke = useSelector((store) => store.entities.remokeTokenReducer);

  const datosComprobante = (data) => {
    comprobanteSet({...state, datos: data});
  };

  const pagar = () => {
    const {data} = storeDataTransaccion.response;
    const {url} = storeDataInformar.response;
    const tbk_token = data.tbkToken;
    let form = document.createElement('form');
    let element1 = document.createElement('input');
    form.method = 'POST';
    form.action = url;
    element1.type = 'hidden';
    element1.value = tbk_token;
    element1.name = 'TBK_TOKEN';
    form.appendChild(element1);
    document.body.appendChild(form);
    form.submit();
  };

  // Setiamos los Desafios Disponible

  const desafiosDisponible = (desafios) => {
    const opciones = desafios.slice().reverse();
    setState({
      ...state,
      desafios: opciones,
      estadoTcoo: desafios[0].byPass ? DESAFIO_NO_DISPONIBLE : desafios[0].estado,
      estadoPassCoopeuch:  desafios[1].byPass ? DESAFIO_NO_DISPONIBLE : desafios[1].estado,
      tercerFactorDisp: !desafios[2].byPass,
    });
  };

  // Autorizamos passCoopeuch

  const autorizarPassCoopeuch = (e) => {
    const {data} = storeDataIngresar.response;
    const getCode = data ? data.code : '';
    const params = {
      trackid: trackId,
      autorizacion: getCode,
    };
    dispatch(generarDesafioCPAction.fetchGenerarDesafioCP(params));
  };

  //Validamos PassCoopeuch

  const validarPassCoopeuch = (codigo) => {
    const {data} = storeDataIngresar.response;
    const getCode = data ? data.code : '';
    const paramsBody = {
      codigo: codigo,
      trackid: trackId,
      autorizacion: getCode,
    };
    dispatch(validarDesafioCPAction.fetchValidarDesafioCP(paramsBody));
  };

  // Generamos Coordenadas

  const generarTcco = () => {
    const {data} = storeDataIngresar.response;
    const getCode = data ? data.code : '';
    setState({
      ...state,
      loderAction: true,
    });
    const params = {
      trackid: trackId,
      autorizacion: getCode,
    };
    dispatch(generarDesafioTcooAction.fetchGenerarTcoo(params));
  };

  // Validamos Coordenadas

  const valueCoordenadas = (e) => {
    if (!e.errors) {
      const {data} = storeDataIngresar.response;
      const getCode = data ? data.code : '';
      setDisableInputTcoo(true);
      const datos = {
        trackid: trackId,
        coordenadas: e.values,
        autorizacion: getCode,
      };
      dispatch(validarDesafioTcooAction.fetchValidarDesafioTcoo(datos));
      // Activar loader General
    }
  };

  // Reintentar PassCoopeuch

  const reintentarPassCoopeuch = () => {
    clearInterval(interval);
    const {data} = storeDataIngresar.response;
    const getCode = data ? data.code : '';
    const params = {
      trackid: trackId,
      autorizacion: getCode,
    };
    dispatch(generarDesafioCPAction.fetchGenerarDesafioCP(params));
    setState({
      ...state,
      usuarioCancelo: false,
      appBloqueada: false,
      casoBorde: false,
      flag: true,
    });
  };

  // Reintentar Tcoo
  const reintentar = () => {
    setValues(['', '', '']);
    setCustomHelperProperties(null);
    setDisableInputTcoo(false);
    generarTcco();
  };

  //Cancelar Flujo
  const revokeToken = () => {
    const {data} = storeDataIngresar.response;
    const autorizacion = data.code;
    dispatch(revokeTokenAction.fetchRevokeToken(autorizacion));
  };

  const finalizar = () => {
    const {data} = storeDataIngresar.response;
    const getCode = data ? data.code : '';
    const params = {
      trackid: trackId,
      Authorization: getCode,
    };
    dispatch(informarAction.fetchInformar(params));
  };

  const obtenerDesafios = () => {
    const trackId = localStorage.getItem('Track-Id');
    dispatch(desafiosAction.fetchDesafios(trackId));
  };

  /* UseEffect */

  // Validamos
  useEffect(() => {
    const Validamos = () => {
      const {data} = storeDataIngresar.response;
      const trackId = localStorage.getItem('Track-Id');
      const getCode = data ? data.code : '';
      const parametros = {
        trackId: trackId,
        Authorization: getCode,
      };
      dispatch(validarAction.fetchValidar(parametros));
    };
    Validamos();
  }, []);

  // Obtenemos la repuesta del validarCuentaVista
  useEffect(() => {
    const ValidamosCuentaVista = () => {
      const {codigo, data} = storeData.response;

      if (codigo >= '1') {
        history.push('/error/autorizacion');
      }
      if (data) {
        datosComprobante(data);
        setState({
          ...state,
          saldoDisponible: data.existeSaldoDisponible,
          tarjetaActiva: data.tarjetaActiva,
        });
        const {existeSaldoDisponible, tarjetaActiva} = data;
        if (existeSaldoDisponible && tarjetaActiva) obtenerDesafios();
        // console.log('validarCuentaVista-',data);
      }
    };
    ValidamosCuentaVista();
  }, [storeData]);

  //Setiamos los desafios disponibles
  useEffect(() => {
    const {data, codigo} = storeDataDesafio.response;
    if (codigo === '17') {
      setState({...state, sinFactorStado: true});
    }

    if (data) {
      desafiosDisponible(data);
    }
  }, [storeDataDesafio]);

  //Setiamos imagen comercio
  useEffect(() => {
    const {data} = storeDataTransaccion.response;
    if (data) {
      setState({...state, logo: data.logoComercio});
    }
  }, [storeDataTransaccion]);

  // Generamos PassCoopeuch
  useEffect(() => {
    const {codigo, data} = storeDataGenerarCP.response;

    if (codigo === '0') {
      const codigoServicio = data.codigo;
      let valorInterval = setInterval(() => {
        validarPassCoopeuch(codigoServicio);
      }, 4000);
      localStorage.setItem('setIntervalPassCoopeuch', valorInterval);
      setState({...state, flag: true});
    }
  }, [storeDataGenerarCP]);

  //Validamos PassCoopeuch

  useEffect(() => {
    const {codigo, data} = storeDataValidarCP.response;
    const trackId = localStorage.getItem('Track-Id');
    if (codigo === '18') {
      clearInterval(interval);
      setState({
        ...state,
        usuarioCancelo: false,
        appBloqueada: true,
        flag: false,
        casoBorde: true,
      });
    }

    if (codigo === '15') {
      clearInterval(interval);
      setState({
        ...state,
        usuarioCancelo: true,
        flag: false,
        casoBorde: true,
      });
    }
    if (codigo === '0') {
      const codigoServicio = data.codigo;

      // exito
      if (codigoServicio === 0) {
        clearInterval(interval);
        const {data} = storeDataIngresar.response;
        const getCode = data ? data.code : '';
        const params = {
          trackid: trackId,
          Authorization: getCode,
        };
        // dispatch(informarAction.fetchInformar(params));
        if (state.tercerFactorDisp) {
          setState({...state, passcoopeuchCompletado: true});
          enviarSMS();
        } else {
          setState({...state, passcoopeuchCompletado: true, botonPagar: true});
        }
      }
    }
  }, [storeDataValidarCP]);

  //Obtener Coordenadas
  useEffect(() => {
    const {codigo, data} = storeDataGenerarTcoo.response;
    if (codigo === '0') {
      setState({...state, coordenadas: data, loderAction: false});
    }
  }, [storeDataGenerarTcoo]);

  //Validar Coordenadas

  useEffect(() => {
    const {codigo} = storeDataValidarTcoo.response;
    if (codigo === '0') {
      clearInterval(interval);
      setDisableInputTcoo(true);
      window.scrollTo(0, document.body.scrollHeight);

      if (state.tercerFactorDisp) {
        setState({...state, tcooCompletado: true});
        enviarSMS();
      } else {
        setState({...state, tcooCompletado: true, botonPagar: true});
      }
    }

    if (codigo === '12') {
      setCustomHelperProperties({
        type: 'error',
        message: 'Las coordenadas ingresadas son incorrectas.',
        withRetryButton: true,
        withIcon: true,
      });

      setDisableInputTcoo(true);
    }
    if (codigo === '11') {
      setCustomHelperProperties({
        type: 'custom',
        content: (
          <Mensaje
            imagen={errorImagen}
            titulo={'Has excedido el límite de intentos.'}
            parrafo={
              'Tu tarjeta de coordenadas se encuentra bloqueada. Para desbloquearla, llámanos al'
            }
            finBold={'600 200 1200.'}
            colorCaja={'#F9D4D5'}
          />
        ),
      });
      setDisableInputTcoo(true);
    }
  }, [storeDataValidarTcoo]);

  const informar = () => {
    dispatch(sesionAction.fetchSesion(trackId));
  };

  // Informamos/service
  useEffect(() => {
    const {codigo, url} = storeDataInformar.response;
    if (codigo === '0') {
      informar();
    }
  }, [storeDataInformar]);

  //Redireccionamos/service
  useEffect(() => {
    const {codigo} = storeDataSesion.response;
    if (codigo === '0') {
      pagar();
    }
  }, [storeDataSesion]);

  useEffect(() => {
    const {codigo} = storeRevoke.response;
    if (codigo === '0') {
      window.location.href = 'https://www.coopeuch.cl/';
    }
  });

  // Envio de SMS
  const enviarSMS = () => {
    dispatch(desafiosAction.fetchDesafioSolicitar(trackId));
  };

  const enviarDigitosSMS = (clave) => {
    let params = {
      otp: clave,
      trackId: trackId,
    };
    dispatch(desafiosAction.fetchDesafioValidar(params));
  };

  const reintentarEnvioSMS = (e) => {
    if (
      'tercerFactor' in storeDataDesafio.response &&
      'validar' in storeDataDesafio.response.tercerFactor &&
      ['25', '20'].includes(storeDataDesafio.response.tercerFactor.validar.codigo)
    ) {
      setState({
        ...state,
        casoBordeIntentosFallidos: true,
        disabledCoordenadasSMS: true,
        mostrarCoordenadasSMS: true,
        timerStatus: false
      });
    }
  };

  useEffect(() => {
    if (
      'tercerFactor' in storeDataDesafio.response &&
      storeDataDesafio.error == false &&
      'solicitar' in storeDataDesafio.response.tercerFactor &&
      storeDataDesafio.response.tercerFactor.solicitar.codigo === '0'
    ) {
      setState({
        ...state,
        mostrarCoordenadasSMS: true,
        celular: storeDataDesafio.response.tercerFactor.solicitar.celular,
      });
    } else if (
      'tercerFactor' in storeDataDesafio.response &&
      'solicitar' in storeDataDesafio.response.tercerFactor &&
      ['25', '20'].includes(storeDataDesafio.response.tercerFactor.solicitar.codigo)
    ) {
      setState({...state, casoBordeIntentosFallidos: true, disabledCoordenadasSMS: true, mostrarCoordenadasSMS: true});
    } else if (
      storeDataDesafio.error ||
      ('tercerFactor' in storeDataDesafio.response &&
        'solicitar' in storeDataDesafio.response.tercerFactor &&
        ['21', '22', '23', '24'].includes(storeDataDesafio.response.tercerFactor.solicitar.codigo))
    ) {
      setState({
        ...state,
        casoBordeErrorGenerico: true,
        mostrarCoordenadasSMS: true,
      });
    }

    if (
      'tercerFactor' in storeDataDesafio.response &&
      'validar' in storeDataDesafio.response.tercerFactor &&
      storeDataDesafio.response.tercerFactor.validar.codigo === '0'
    ) {
      setState({...state, botonPagar: true, disabledCoordenadasSMS: true});
    } else if (
      'tercerFactor' in storeDataDesafio.response &&
      'validar' in storeDataDesafio.response.tercerFactor &&
      storeDataDesafio.response.tercerFactor.validar.codigo == '25'
    ) {
      setState({
        ...state,
        casoBordeIntentosFallidos: true,
        disabledCoordenadasSMS: true,
        mostrarCoordenadasSMS: true,
        timerStatus: false
      });


    } else if (storeDataDesafio.error) {
      setState({
        ...state,
        casoBordeErrorGenerico: true,
        disabledCoordenadasSMS: true
      });
    }
  }, [storeDataDesafio.response]);

  const {
    logo,
    desafios,
    coordenadas,
    estadoTcoo,
    estadoPassCoopeuch,
    timerStatus,
    loderAction,
    saldoDisponible,
    tarjetaActiva,
    usuarioCancelo,
    appBloqueada,
    flag,
    casoBorde,
    botonPagar,
    mostrarCoordenadasSMS,
    disabledCoordenadasSMS,
    celular,
    casoBordeIntentosFallidos,
    casoBordeErrorGenerico,
    sinFactorStado,
    mensajeErrorEnviarDigitosSMS,
    mensajeExitoEnviarDigitosSMS,
    tercerFactorDisp,
    passcoopeuchCompletado,
    tcooCompletado,
  } = state;

  return (
    <>
      <AutorizacionTemplate
        cancelarFlujo={revokeToken}
        datosComprobante={comprobante}
        logo={logo}
        desafios={desafios}
        coordenadasServicio={coordenadas}
        setvalueCoordenadas={valueCoordenadas}
        tcooEstado={estadoTcoo}
        cpEstado={estadoPassCoopeuch}
        reintentarDesadioTcoo={reintentar}
        onSubmitAuthCP={autorizarPassCoopeuch}
        onSubmitHandle={finalizar}
        onSubmitReintentarPC={reintentarPassCoopeuch}
        onSumitTcco={generarTcco}
        statusTime={timerStatus}
        loader={loderAction}
        estadoSaldoDisponible={saldoDisponible}
        estadoTarjeta={tarjetaActiva}
        usuarioCanceloPC={usuarioCancelo}
        appBloqueadaPC={appBloqueada}
        inicioPassCoopeuch={flag}
        casoBordeState={casoBorde}
        customHelper={customHelperProperties}
        values={valuesCoordenadas}
        disableInputs={disableInputTcoo}
        pagar={botonPagar}
        mostrarCoordenadasSMS={mostrarCoordenadasSMS}
        enviarDigitosSMS={enviarDigitosSMS}
        reintentarEnvioSMS={reintentarEnvioSMS}
        celular={celular}
        disabledCoordenadasSMS={disabledCoordenadasSMS}
        casoBordeIntentosFallidos={casoBordeIntentosFallidos}
        casoBordeErrorGenerico={casoBordeErrorGenerico}
        mensajeErrorEnviarDigitosSMS={mensajeErrorEnviarDigitosSMS}
        mensajeExitoEnviarDigitosSMS={mensajeExitoEnviarDigitosSMS}
        sinFactorSet={sinFactorStado}
        tercerFactorDisp={tercerFactorDisp}
        passcoopeuchCompletado={passcoopeuchCompletado}
        tcooCompletado={tcooCompletado}
      />
    </>
  );
};

export default AutorizacionContainer;
